/**
 * EnhancedButton
 * Button base class with enhancements
 *
 * @module  EnhancedButton.js
 * @author  Randy Lebeau
 * @contributor Yevgeniy Rokhlin
 *
 */

import React from 'react';
import KeyCode from 'utils/key-code';
import ClassNames from 'classnames';
import PropsJoin from 'mixins/js/PropsJoin';
import WindowListeners from 'mixins/js/WindowListeners';
import FocusRipple from 'components/animations/focus-ripple/FocusRipple';
import TouchRipple from 'components/animations/touch-ripple/TouchRipple';
import LinkMixin from 'mixins/js/LinkMixin';

import Router from 'react-router-component';
const Link = Router.Link;


export default React.createClass({

	displayName: "EnhancedButton",

	mixins: [ WindowListeners, PropsJoin, LinkMixin ],

	propTypes: {
		className: React.PropTypes.string,
		centerRipple: React.PropTypes.bool,
		disabled: React.PropTypes.bool,
		disableFocusRipple: React.PropTypes.bool,
		disableTouchRipple: React.PropTypes.bool,
		onBlur: React.PropTypes.func,
		onFocus: React.PropTypes.func,
		onTouchTap: React.PropTypes.func
	},

	windowListeners: {
		'keydown': '_handleWindowKeydown',
		'keyup': '_handleWindowKeyup'
	},

	getInitialState() {
		return {
			isKeyboardFocused: false
		};
	},

	getDefaultProps() {
		return {
			href: '',
			target: '_self'
		}
	},

	render() {

		let onClickAction,
			hrefAction;

		let {
			centerRipple,
			disabled,
			disableFocusRipple,
			disableTouchRipple,
			linkButton,
			onBlur,
			onFocus,
			onTouchTap,
			className,
			href,
			active,
			onClick,
			target } = this.props;

		let classes = ClassNames('lui-enhanced-button', className, {
			'lui-is-disabled': disabled,
			'lui-is-keyboard-focused': this.state.isKeyboardFocused,
			'lui-is-link-button': linkButton,
			'lui-is-active' : active
		});

		let touchRipple = (
			<TouchRipple
				ref="touchRipple"
				key="touchRipple"
				centerRipple={centerRipple}>
				{this.props.children}
			</TouchRipple>
		);

		let focusRipple = (
			  <FocusRipple
				key="focusRipple"
				show={this.state.isKeyboardFocused} />
		);

		let buttonProps = {};

		Object.assign(buttonProps, this.props);
		
		Object.assign(buttonProps , {
			className: classes,
			onBlur: this._handleBlur,
			onFocus: this._handleFocus,
			onTouchTap: this._handleTouchTap,
			href: !disabled ? href : '',
			onClick: !disabled ? onClick : null
		});

		let buttonChildren = [
			disabled || disableTouchRipple ? this.props.children : touchRipple,
			disabled || disableFocusRipple ? null : focusRipple
		];

		return href !== '' ? (
			<Link {...buttonProps} >
				<button {...buttonProps} style={{width:'100%'}}>
					{buttonChildren}
				</button>
			</Link>
		):(
			<button {...buttonProps}>
				{buttonChildren}
			</button>
		);
	},

	isKeyboardFocused() {
		return this.state.isKeyboardFocused;
	},

	_handleWindowKeydown(e) {
		if (e.keyCode == KeyCode.TAB) this._tabPressed = true;
		if (e.keyCode == KeyCode.ENTER && this.state.isKeyboardFocused) {
			this._handleTouchTap(e);
		}
	},

	_handleWindowKeyup(e) {
		if (e.keyCode == KeyCode.SPACE && this.state.isKeyboardFocused) {
			this._handleTouchTap(e);
		}
	},

	_handleBlur(e) {
		this.setState({
			isKeyboardFocused: false
		});

		if (this.props.onBlur) this.props.onBlur(e);
	},

	_handleFocus(e) {
		//setTimeout is needed becuase the focus event fires first
		//Wait so that we can capture if this was a keyboard focus
		//or touch focus
		setTimeout(function() {
			if (this._tabPressed) {
				this.setState({
					isKeyboardFocused: true
				});
			}
		}.bind(this), 150);

		if (this.props.onFocus) this.props.onFocus(e);
	},

	_handleTouchTap(e) {
		this._tabPressed = false;
		this.setState({
			isKeyboardFocused: false
		});
		if (this.props.onTouchTap) this.props.onTouchTap(e);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/buttons/enhanced-button/EnhancedButton.js
 **/